import { useEffect, useRef } from 'react'
import QRCode from 'qrcode'

/**
 * Joining by QR is the difference between "everyone is in" in ten seconds and
 * three people typing a URL wrong. Rendered locally - nothing is sent anywhere.
 */
export function QrCode({ value, size = 160 }: { value: string; size?: number }) {
  const canvas = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const el = canvas.current
    if (!el) return
    void QRCode.toCanvas(el, value, {
      width: size,
      margin: 1,
      color: { dark: '#0b0d11', light: '#ffffff' },
      errorCorrectionLevel: 'M',
    })
  }, [value, size])

  return (
    <div className="qr">
      <canvas ref={canvas} width={size} height={size} aria-label={`QR code for ${value}`} />
    </div>
  )
}
